import { Dialog, DialogContent } from '@/core/ui';
import { Typography, dialogActionsClasses, styled } from '@mui/material';
const getIconBackgroundColor = ({ palette }, variant) => {
    return palette[variant].lightest;
};
const getIconColor = ({ palette }, variant) => {
    return palette[variant].dark;
};
export const DialogStyled = styled(Dialog)(({ theme }) => ({
    // This zIndex is used here to avoid the bug when a parent dialog has a tooltip opened and this tooltip overlaps child dialog
    // (this ConfirmationDialog) and is shown above it. But child dialog should hide everything behind itself.
    zIndex: theme.zIndex.tooltip + 1000,
    [`.${dialogActionsClasses.root}`]: {
        backgroundColor: theme.palette.background.paper,
    },
}));
export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
    flexDirection: 'row',
    padding: theme.spacing(6, 6, 4, 6),
}));
export const IconContainer = styled('div', { shouldForwardProp: (prop) => prop !== 'variant' })(({ theme, variant = 'warning' }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '9999px',
    height: '2.5rem',
    width: '2.5rem',
    backgroundColor: getIconBackgroundColor(theme, variant),
    '> svg': {
        fontSize: '1.5rem',
        color: getIconColor(theme, variant),
    },
}));
export const TitleAndContentContainer = styled('div')(({ theme }) => ({
    marginLeft: theme.spacing(6),
}));
export const TitleText = styled(Typography)(({ theme }) => ({
    lineHeight: '1.5',
    fontWeight: theme.typography.fontWeightBold,
}));
export const ContentContainer = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(2),
}));
export const ContentText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.muted,
    b: {
        color: theme.palette.text.primary,
    },
}));
